import { render } from "./DotsSvg.vue?vue&type=template&id=2df933a8&scoped=true"
import script from "./DotsSvg.vue?vue&type=script&lang=ts"
export * from "./DotsSvg.vue?vue&type=script&lang=ts"

import "./DotsSvg.vue?vue&type=style&index=0&id=2df933a8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2df933a8"

export default script